import React, { useState } from "react";
import { Card, Input, Button, Typography, Row, Col, Checkbox, Select, Spin, Divider, Layout,Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import axios from "axios";
import Swal from "sweetalert2"; 
import { BASE_URL } from '../../App';
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import {  FileDoneOutlined } from "@ant-design/icons";
const { Title, Text } = Typography;
const { Option } = Select;
const { Header, Content } = Layout;

const XpoBomOrder = () => {
  const [searchType, setSearchType] = useState("serial");
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false); 
  const [loading1, setLoading1] = useState(false); 
  const [loading2, setLoading2] = useState(false); 
  const [data, setData] = useState(null);
  const login_id = localStorage.getItem("LOGIN_ID");
    const branch_code = localStorage.getItem("BRANCH_CODE");
  // const login_id = "5104051";
  // const branch_code = "1601";
  const [items, setItems] = useState([]); 
const [selectedBomCode, setSelectedBomCode] = useState(null); 

const fetchPrice = async (bomCode) => {
  setLoading(true);
  try {
    const response = await axios.post(BASE_URL + "/xpo_pricestock", {
      login_id: login_id,
      bom_code: bomCode,
    });

    if (response.status === 200) {
      if (response.data.status_code === "200") {
        return response.data.itemdetails.base_price; // Fetch the actual price
      } else if (response.data.status_code === "400") {
        Swal.fire({ icon: "info", text: response.data.message || "Invalid selection.", confirmButtonText: "Okay" });
        return null;
      }
    }
  } catch (error) {

    console.error("Error fetching price:", error);
    Swal.fire({ icon: "info", text: "Failed to fetch price, Please Try After Some Time", confirmButtonText: "Okay" });
  } finally {
    setLoading(false);
  }
  return null;
};

const handleAdd = async () => {
  if (!selectedBomCode) {
    Swal.fire({ icon: "info", text: "Please select a BOM first!", confirmButtonText: "Okay" });
    return;
  }
  if (items.some(item => item.mat_code === selectedBomCode)) {
    Swal.fire({ icon: "warning", text: "Item already added!", confirmButtonText: "Okay" });
    return;
  }
  const price = await fetchPrice(selectedBomCode);
  if (price === null||price === 0) return; 
  const bomDetails = data?.bom_details?.find(item => item.BOM_CODE === selectedBomCode);
  const description = bomDetails ? `${bomDetails.BOM_CODE} - ${bomDetails.BOM_DESCRIPTION}` : "Unknown";
  const packQty = Number(bomDetails?.PACK_QTY) > 1 ? Number(bomDetails.PACK_QTY) : 1; // ✅ Condition added
  const newItem = {
    key: selectedBomCode,
    mat_code: selectedBomCode,
    description,
    price: parseFloat(price),
    qty: packQty,
    total: parseFloat(price),
   };
  // const newItem = {
  //   key: selectedBomCode,
  //   mat_code: selectedBomCode,
  //   description: data?.bom_details?.find(item => item.BOM_CODE === selectedBomCode)?.`${BOM_DESCRIPTION}-${BOM_CODE}`|| "Unknown",
  //   price: parseFloat(price), // Ensure it's a number
  //   qty: 1,
  //   total: parseFloat(price),
  // };

  setItems([...items, newItem]);
};
// const handleQtyChange = (value, key) => {
//   const selectedItem = items.find(item => item.key === key);
//   if (!selectedItem) return;

//   // Find the corresponding BOM details using BOM_CODE (ensure correct matching)
//   const bomDetails = data?.bom_details?.find(item => item.BOM_CODE.trim() === key.trim());

//   if (!bomDetails) {
//     console.warn(`No BOM details found for key: ${key}`);
//     return;
//   }

//   const maxQty = Number(bomDetails.EXTENDED_QUANTITY) || 0;

//   if (value > maxQty) {
//     Swal.fire({ 
//       icon: "info", 
//       text: `Sorry You Cross the Extended Quantity. it must with in ${maxQty} Qty`, 
//       confirmButtonText: "Okay" 
//     });
//     return;
//   }

//   setItems(items.map(item =>
//     item.key === key ? { ...item, qty: value, total: (value * item.price).toFixed(2) } : item
//   ));
// };


const handleQtyChange = (value, key) => {
  const selectedItem = items.find(item => item.key === key);
  if (!selectedItem) return;

  const bomDetails = data?.bom_details?.find(item => item.BOM_CODE.trim() === key.trim());

  if (!bomDetails) {
    console.warn(`No BOM details found for key: ${key}`);
    return;
  }

  

  // Update Items
  setItems(items.map(item =>
    item.key === key ? { ...item, qty: value, total: (value * item.price).toFixed(2) } : item
  ));
};


// Handle Delete Row
const handleDelete = (key) => {
  setItems(items.filter((item) => item.key !== key));
};

  const columns = [
    { title: "Item Description", dataIndex: "description", key: "description" },
    { title: "Price", dataIndex: "price", key: "price" },
    {
      title: "Quantity",
      dataIndex: "qty",
      key: "qty",
      render: (text, record) => (
        <Input
          //type="number"
          
          value={record.qty}
          onChange={(e) => handleQtyChange(Number(e.target.value), record.key)}
        />
      ),
    },
    { title: "Total", dataIndex: "total", key: "total" },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Button type="danger" icon={<DeleteOutlined />} onClick={() => handleDelete(record.key)} />
      ),
    },
  ];const handleGenerateOrder = async () => {
    if (items.length === 0) {
      Swal.fire({ icon: "warning", text: "No items to order!", confirmButtonText: "Okay" });
      return;
    }
   
    for (const item of items) {
      const bomDetails = data?.bom_details?.find(bom => bom.BOM_CODE === item.mat_code);
    
      if (!bomDetails) {
        console.warn(`No BOM details found for item: ${item.mat_code}`);
        continue;
      }
    
      const packQty = Number(bomDetails.PACK_QTY) || 0; 
      const maxQty = Number(bomDetails.EXTENDED_QUANTITY) || 0; 
      const quantity = Number(item.qty) || 0;
    
      const ratio = packQty > 0 && maxQty > 0 ? packQty / maxQty : 1;
    
     
      const isMultiple = Number.isInteger(quantity / packQty);
    
     
      if (packQty > 1 && !isMultiple) {
        Swal.fire({ 
          icon: "info", 
          text: `Item - ${item.mat_code} quantity should be in multiples of ${packQty}`, 
          confirmButtonText: "Okay" 
        });
        return;
      }
    
      
      if (packQty > maxQty) {
        const exactRatio = quantity / maxQty;
        if (exactRatio > ratio) {
          Swal.fire({ 
            icon: "info", 
            text: `Item - ${item.mat_code} crossed the Packed Quantity. Allowed within ${packQty} Qty`, 
            confirmButtonText: "Okay" 
          });
          return;
        }
      }
    
      
      else if (quantity > maxQty) {
        Swal.fire({ 
          icon: "info", 
          text: `Item - ${item.mat_code} crossed the Packed Quantity. Allowed within ${maxQty} Qty`, 
          confirmButtonText: "Okay" 
        });
        return;
      }
    }
    
    setLoading2(true);
    try {
      const grandTotal = items.reduce((sum, item) => sum + Number(item.total || 0), 0);
  
      const response = await axios.post(BASE_URL + "/xpo_bom_order_creation", {
        login_id: login_id,
        bom_code: items, 
        gtotal: grandTotal,
        type:searchType,
        code:searchValue,
        mat_code:data.mat_code,
        mat_desc:data.mat_desc,
      });
  
      if (response.status === 200) {
        if (response.data.status_code === "200") {
          setItems([]);
          setData(null);
          Swal.fire({
            icon: "success",
            text: response.data.message,
            confirmButtonText: "Okay",
          });
        } else if (response.data.status_code === "400") {
          Swal.fire({ icon: "info", text: response.data.message || "Invalid selection.", confirmButtonText: "Okay" });
        }
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: "Order is not generated. Please try again!",
        confirmButtonText: "Okay",
      });
      console.error("Error fetching price:", error);
    } finally {
      setLoading2(false);
    }
  };
  
  
  const handleSearch = async () => {
    if (!searchValue.trim()) {
      Swal.fire({
        icon: "info",
        text: "Please enter a value to search.",
        confirmButtonText: "Okay",
      });
      return;
    }

    try {
      setLoading1(true);
      setData(null);
      setItems([])
      const response = await axios.post(BASE_URL + '/xpo_serialno', {
        login_id: login_id,
        branch_code: branch_code,
        ...(searchType === "serial" ? { serial_no: searchValue } : { mat_code: searchValue })
      });
      
      if (response.status === 200) {
        if (response.data.status_code === "400") {
          Swal.fire({
            icon: "info",
            text: response.data.message,
            confirmButtonText: "Okay",
          });
        } else if (response.data.status_code === "200") {
          setData(response.data);
          // Swal.fire({
          //   icon: "success",
          //   title: "Success",
          //   text: "Data retrieved successfully!",
          //   confirmButtonText: "Okay",
          // });
        }
      }
    } catch (error) {
      console.error("Error uploading data:", error);
      Swal.fire({
        icon: "error",
        text: "Error retrieving data. Please try again.",
        confirmButtonText: "Okay",
      });
    } finally {
      setLoading1(false);
    }
  };

  const handleSearchTypeChange = (newType) => {
    setSearchType(newType);
    setData(null);
    setItems([])
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/* <Header style={{ background: "#1890ff", padding: "0 24px" }}>
        <Title level={3} style={{ color: "#fff", margin: 0, lineHeight: "64px" }}>
          XPO BOM Order
        </Title>
      </Header> */}
      <Content style={{ padding: "16px 30px" }}>  
  <Card style={{ marginBottom: 6, padding: 10, borderRadius: 6 }}>
    <Row justify="center" gutter={8} style={{ marginBottom: 8 }}>
      <Checkbox
        checked={searchType === "serial"}
        onChange={() => handleSearchTypeChange("serial")}
      >
        Serial Number
      </Checkbox>
   {/* //   <Checkbox
      //  checked={searchType === "product"}
     //   onChange={() => handleSearchTypeChange("product")}
      //</Row>>
       // Product
    //  </Checkbox> */}
    </Row>

    <Row justify="center" gutter={8}>
      <Col>
        <Input
          placeholder={searchType === "serial" ? "Enter Serial No" : "Enter Product"}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          style={{ width: 240, borderRadius: 6 }}
        />
      </Col>
      <Col>
        <Button 
          type="primary" 
          icon={<SearchOutlined />} 
          onClick={handleSearch} 
          loading={loading1} 
          style={{ borderRadius: 6 }}
        >
          Search
        </Button>
      </Col>
    </Row>

    {/* {loading && (
      <Row justify="center" style={{ marginTop: 8 }}>
        <Spin size="small" />
      </Row>
    )} */}
  </Card>

  {data && (
    <>
      {/* First Card - Product & Serial Number */}
      <Card style={{ padding: 8, marginBottom: 6, borderRadius: 6 }}>
        <Row justify="space-between" align="middle" gutter={6}>
          {/* Left - Product Details */}
          <Col span={ 8}>
            <Divider orientation="left" style={{ margin: "2px 0", padding: 4 }}>
              <Text style={{ color: "#1890ff", fontWeight: 600 }}>
                Product Details
              </Text>
            </Divider>
            <Text strong style={{ color: "#595959" }}>
              {data.mat_code} - {data.mat_desc}
            </Text>
          </Col>
          <Col span={ 12}>
            <Divider orientation="left" style={{ margin: "2px 0", padding: 4 }}>
              <Text style={{ color: "#1890ff", fontWeight: 600 }}>
              BOM Details
              </Text>
            </Divider>
            <Select
                  placeholder="Select BOM"
                  style={{ width: "80%", borderRadius: 6 }}
                  showSearch
                  optionFilterProp="children"
                  onChange={(value) => setSelectedBomCode(value)} 
                >
                  {data.bom_details.map((item) => (
                    <Option key={item.BOM_CODE} value={item.BOM_CODE}>
                      {item.BOM_CODE} - {item.BOM_DESCRIPTION}
                    </Option>
                  ))}
                </Select>
                &nbsp;
                <Button 
  type="primary" 
  icon={<PlusOutlined />} 
  style={{ borderRadius: 6 }} 
  onClick={handleAdd} 
  loading={loading} // Show loading when API call is in progress
>
  Add
</Button>

          </Col>

         
          {searchType === "serial" && (
            <Col span={4} style={{ textAlign: "left" }}>
              <Divider orientation="left" style={{ margin: "2px 0", padding: 4 }}>
                <Text style={{ color: "#1890ff", fontWeight: 600 }}>
                  Serial Number
                </Text>
              </Divider>
              <Text strong style={{ color: "#595959" }}>
              
                {searchValue}
        

              </Text>
            </Col>
              )}
        </Row>
      </Card>


    
    </>
  )}
  {/* {items.length > 0 && (
  <Table dataSource={items} columns={[
    { title: "Item Description", dataIndex: "description", key: "description" },
    { title: "Price", dataIndex: "price", key: "price" },
    {
      title: "Qty",
      dataIndex: "qty",
      key: "qty",
      render: (text, record) => (
        <Input type="number" min={1} value={record.qty} onChange={(e) => handleQtyChange(Number(e.target.value), record.key)} />
      ),
    },
    { title: "Total", dataIndex: "total", key: "total" },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Button type="danger" icon={<DeleteOutlined />} onClick={() => handleDelete(record.key)} />
      ),
    },
  ]} style={{ marginTop: 16 }} />
)} */}
<Table
  dataSource={items}
  columns={[
    { title: "Item Description", dataIndex: "description", key: "description" },
    { title: "Price", dataIndex: "price", key: "price" },
    {
      title: "Qty",
      dataIndex: "qty",
      key: "qty",
      render: (text, record) => (
        <Input
         // type="number"
         
          value={record.qty}
          onChange={(e) => handleQtyChange(Number(e.target.value), record.key)}
        />
      ),
    },
    { title: "Total", dataIndex: "total", key: "total" },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Button
          type="danger"
          icon={<DeleteOutlined />}
          onClick={() => handleDelete(record.key)}
        />
      ),
    },
  ]}
  style={{ marginTop: 16 }}
  summary={() => {
    const grandTotal = items.reduce((sum, item) => sum + Number(item.total || 0), 0);
    return (
      <Table.Summary.Row>
        <Table.Summary.Cell colSpan={3}>
          <strong>Grand Total:</strong>
        </Table.Summary.Cell>
        <Table.Summary.Cell>
          <strong>{grandTotal.toFixed(2)}</strong>
        </Table.Summary.Cell>
        <Table.Summary.Cell />
      </Table.Summary.Row>
    );
  }}
/>
<div style={{ textAlign: "center", marginTop: "20px" }}>
  <Button
    type="primary"
    icon={<FileDoneOutlined />}
    size="large"
    loading={loading2}
    onClick={handleGenerateOrder}
    disabled={items.length === 0} // Disable if no items
  >
    Generate Order
  </Button>
</div>


</Content>

    </Layout>
  );
};

export default XpoBomOrder;
